import * as Color from 'color';
import * as React from 'react';
import { Card } from 'reactstrap';
import getClientEnvironment from '../../../getClientEnvironment';
import ActivityCardBody from '../ActivityCardBody';
import { ActivityPayload } from '../types';
import ActivityMapImage from './ActivityMapImage';

const config = getClientEnvironment();

const pathColor = Color(config.THEME_COLOR)
    .darken(0.2)
    .hex();

/**
 * Card which is displayed in the main activity list
 */
const ActivityListCard = (props: ActivityPayload) => {
    const { activity } = props;

    if (!activity) {
        return <p>Activity not found</p>;
    }

    return (
        <Card className="ml-3 mb-3 activity-card">
            <ActivityCardBody {...props} className="activity-card-left" />
            <div className="activity-card-right">
                <ActivityMapImage activity={activity} pathColor={pathColor} />
            </div>
        </Card>
    );
};

export default ActivityListCard;



// WEBPACK FOOTER //
// ./src/client/components/Strava/ActivityListScene/ActivityListCard.tsx